
<div class="notification">
  <div>
    <span class="imgSection">
      <img src="{{data.image}}" alt="img"/> 
    </span>
  <span> {{ data.message }}</span>
</div>

</div>

